import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";
import fetchIdentityOptions from "../helpers/Customer/fetchIdentityOptions";
import { addBase64Prefix, getLatestImage } from "../helpers/image";
import usePhoto from "./usePhoto";
import LoadingAction from "@common/redux/actions/LoadingAction";
import AlertModalAction from "@common/redux/actions/AlertModalAction";
import { handleError } from "../helpers/error";
import CustomerClient from "@common/api/CustomerClient";
import useLogin from "./useLogin";

const useCustomerEdit = ({ handleEditCustomer, customers }) => {
  const setIdentityFormState = (data) => IdentityFormModalAction.dispatch(data);
  const { setPhotoState } = usePhoto();
  const [{ isDesktop }] = useLogin();

  const updateCustomer = (customerData) =>
    LoadingAction.set(true).then(() => {
      CustomerClient.Update(customerData).then(
        (response) => {
          LoadingAction.set(false);
          AlertModalAction.open("Successfully updated customer!", "Success");
        },
        (error) => handleError(error),
      );
    });

  const prepareCustomerEditForm = (customer) => {
    fetchIdentityOptions();
    const selectedCustomer = customers.find((x) => x.id === customer.id);
    if (!selectedCustomer) return;

    const features = selectedCustomer.features.split(",")[6]?.trim() || "";

    const identityFormData = isDesktop
      ? selectedCustomer
      : { ...selectedCustomer, features };

    setIdentityFormState({ identityFormData });

    if (!isDesktop) {
      /** Set the photo of the customer in the PhotoComponent:
        1. selectedCustomer.image represents the single image currently being edited
        by the user in the frontend interface.
        2. getLatestImage(selectedCustomer) retrieves the most recent image from the
        array selectedCustomer.images that is returned from the backend.
      */
      const photo =
        addBase64Prefix(selectedCustomer.image) ??
        addBase64Prefix(getLatestImage(selectedCustomer)?.image);
      setPhotoState({ photo });
    }
  };

  const editCustomer = ({ hideName, customer }) => {
    IdentityFormModalAction.open(
      () => prepareCustomerEditForm(customer),
      handleEditCustomer,
      {
        title: "Edit Customer",
        hideName,
        optionalName: hideName,
        showContacts: false,
        isEditing: true,
      },
    );
  };

  return { updateCustomer, prepareCustomerEditForm, editCustomer };
};

export default useCustomerEdit;
